import { createAction } from 'typesafe-actions';

import { BookingsTabId } from 'components/bookings-tabs';

/**
 * The tenant pressed a tab. Writing the value BACK to the host is the caller's job
 * (`useBookingsTab`), not the reducer's.
 *
 * ⭐ SEPARATE FROM `hydrateBookingsTab` ON PURPOSE. The two carry the same payload and mean
 * different things, and only the reducer is in a position to tell them apart -- which is where the
 * race between them is settled.
 */
export const setBookingsTab = createAction('SET_BOOKINGS_TAB')<BookingsTabId>();

/**
 * The host's stored tab, arriving on boot.
 *
 * ⚠️ YIELDS TO ANYTHING THE TENANT HAS ALREADY PRESSED. See `hasLocalChoice`.
 */
export const hydrateBookingsTab = createAction('HYDRATE_BOOKINGS_TAB')<BookingsTabId | null>();
